import { Grid, Typography } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import config from "../../Config/clientConfig.json";
import WSDateField from "../../Components/DateField/WSDateField";
import WSRadioField from "../../Components/Radio/WSRadio";

export const FilterCriteria: React.FC<any> = React.memo((props) => {
    const { register, control } = useFormContext();

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
                <Typography>Report Type</Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
                <WSSelectField
                    rules={{ required: true }}
                    {...register("reporttype")}
                    id="reporttype"
                    control={control}
                    defaultValue={"0"}
                    label=""
                    name="reporttype"
                    options={config.reporttypeConfig.staticOptionData}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Typography>From Date</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <WSDateField
                    id="fromdate"
                    name="fromdate"
                    label=""
                    dateFormat="D/MM/YYYY"
                    control={control}
                    defaultValue={null}
                    rules={{ required: false }}
                />
            </Grid>
            <Grid item xs={12} sm={1}>
                <Typography>To Date</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <WSDateField
                    id="todate"
                    name="todate"
                    label=""
                    dateFormat="D/MM/YYYY"
                    control={control}
                    defaultValue={null}
                    rules={{ required: false }}
                />
            </Grid>

            {/* Grouped Fields */}
            <Grid item xs={12} sm={9}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Typography>Order Type</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            rules={{ required: true }}
                            {...register("ordertype")}
                            id="ordertype"
                            control={control}
                            defaultValue={"0"}
                            label=""
                            name="ordertype"
                            options={config.ordertypeConfig.staticOptionData}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Typography>Server</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            rules={{ required: true }}
                            {...register("server")}
                            id="server"
                            control={control}
                            defaultValue={"0"}
                            label=""
                            name="server"
                            options={config.servertypeConfig.staticOptionData}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Typography>User</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            rules={{ required: true }}
                            {...register("user")}
                            id="user"
                            control={control}
                            defaultValue={"0"}
                            label=""
                            name="user"
                            options={config.userConfig.staticOptionData}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Typography>Menu Group</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            rules={{ required: true }}
                            {...register("menugroup")}
                            id="menugroup"
                            control={control}
                            defaultValue={"0"}
                            label=""
                            name="menugroup"
                            options={config.menugroupConfig.staticOptionData}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Typography>Sub Group</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            rules={{ required: true }}
                            {...register("subgroup")}
                            id="subgroup"
                            control={control}
                            defaultValue={"0"}
                            label=""
                            name="subgroup"
                            options={config.subgroupConfig.staticOptionData}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={3}>
                <WSRadioField
                    id="radio"
                    name="radio"
                    label=""
                    control={control}
                    defaultValue={"radio"}
                    options={config.radioConfig.staticOptionData}
                    rules={{ required: true }}
                />
            </Grid>
        </Grid>
    );
});
